import { useState, useRef } from "react";
import Card from "./ui/Card";
import Btn from "./ui/Btn";

export default function ImportExcel({ toast }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const ref = useRef();

  const handle = async (file) => {
    if (!file) return;
    setLoading(true);
    setResult(null);
    const fd = new FormData();
    fd.append("file", file);
    const token = localStorage.getItem("token");
    const csrfToken = localStorage.getItem("csrf_token");
    try {
      const res = await fetch("/api/import/excel", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "X-CSRF-Token": csrfToken },
        body: fd,
      });
      if (!res.ok) {
        let detail;
        try {
          const d = await res.json();
          detail = d.detail || d.message || `خطأ ${res.status}`;
        } catch {
          detail = `خطأ ${res.status}`;
        }
        throw new Error(detail);
      }
      const data = await res.json();
      setResult(data);
      if (data.imported > 0) toast(`✅ تم استيراد ${data.imported} سجل`);
      else toast("لم يتم استيراد أي سجلات", "warning");
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <h2
        style={{
          fontSize: 20,
          fontWeight: 800,
          margin: "0 0 20px",
          color: "#f1f5f9",
        }}
      >
        📥 استيراد من Excel
      </h2>
      <Card>
        <div
          onClick={() => ref.current.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            handle(e.dataTransfer.files[0]);
          }}
          style={{
            border: "2px dashed #334155",
            borderRadius: 12,
            padding: "40px 24px",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <div style={{ fontSize: 40, marginBottom: 10 }}>📂</div>
          <div style={{ color: "#94a3b8", fontSize: 15, marginBottom: 6 }}>
            اسحب وأفلت ملف Excel هنا
          </div>
          <Btn color="#38bdf8" disabled={loading}>
            {loading ? "⏳ جاري الاستيراد..." : "اختر ملف .xlsx"}
          </Btn>
        </div>
        <input
          ref={ref}
          type="file"
          accept=".xlsx,.xls"
          style={{ display: "none" }}
          onChange={(e) => handle(e.target.files[0])}
        />
        {result && (
          <div
            style={{
              marginTop: 16,
              background: "#0f172a",
              borderRadius: 10,
              padding: 14,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 10,
              }}
            >
              {[
                ["مستورد", result.imported, "#22c55e"],
                ["تجاوزه", result.skipped, "#f59e0b"],
                ["أخطاء", result.errors?.length || 0, "#ef4444"],
              ].map(([l, v, c]) => (
                <div key={l} style={{ textAlign: "center" }}>
                  <div style={{ color: c, fontSize: 24, fontWeight: 800 }}>
                    {v}
                  </div>
                  <div style={{ color: "#64748b", fontSize: 12 }}>{l}</div>
                </div>
              ))}
            </div>
            {result.errors?.length > 0 && (
              <div
                style={{
                  marginTop: 10,
                  border: "1px solid #ef444433",
                  borderRadius: 7,
                  padding: 9,
                }}
              >
                {result.errors.map((e, i) => (
                  <div key={i} style={{ color: "#ef4444", fontSize: 11 }}>
                    • {e}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
